var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.configuration_list") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage overflow-hidden" },
          [
            _c(
              "b-row",
              { staticClass: "justify-content-start no-gutters" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn btnFilter mr-3",
                    attrs: { disabled: _vm.activateSpinner },
                    on: {
                      click: function ($event) {
                        return _vm.onRefresh()
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa-light fa-rotate-right fs-14px" })]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "b-tabs",
              {
                attrs: { "nav-class": "d-none" },
                model: {
                  value: _vm.tabName,
                  callback: function ($$v) {
                    _vm.tabName = $$v
                  },
                  expression: "tabName",
                },
              },
              [
                _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t("common.routing.interprocess_config"),
                    },
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _vm.activateSpinner
                              ? _c("spinner")
                              : _c(
                                  "div",
                                  [
                                    _vm.interProcessFields.length
                                      ? _c("b-table", {
                                          staticClass: "mt-3",
                                          attrs: {
                                            fixed: "",
                                            responsive: "",
                                            items: _vm.interProcessConfigList,
                                            fields: _vm.interProcessFields,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-tab",
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _vm.activateSpinner
                              ? _c("spinner")
                              : _c(
                                  "div",
                                  [
                                    _vm.mqseriesFields.length
                                      ? _c("b-table", {
                                          staticClass: "mt-3",
                                          attrs: {
                                            hover: "",
                                            relative: "",
                                            responsive: "",
                                            items: _vm.mqseriesConfigList,
                                            fields: _vm.mqseriesFields,
                                            selectable: "",
                                            "select-mode": "single",
                                          },
                                          on: {
                                            "row-selected":
                                              _vm.seeMQSeriesDetails,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-tab",
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _vm.activateSpinner
                              ? _c("spinner")
                              : _c(
                                  "div",
                                  [
                                    _vm.remoteFolderFields.length
                                      ? _c("b-table", {
                                          staticClass: "mt-3",
                                          attrs: {
                                            hover: "",
                                            fixed: "",
                                            responsive: "",
                                            items: _vm.remoteFolderConfigList,
                                            fields: _vm.remoteFolderFields,
                                            selectable: "",
                                            "select-mode": "single",
                                          },
                                          on: {
                                            "row-selected":
                                              _vm.seeRemoteFolderDetails,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-tab",
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _vm.activateSpinner
                              ? _c("spinner")
                              : _c(
                                  "div",
                                  [
                                    _vm.webServiceFields.length
                                      ? _c("b-table", {
                                          staticClass: "mt-3",
                                          attrs: {
                                            hover: "",
                                            fixed: "",
                                            responsive: "",
                                            items: _vm.webServiceConfigList,
                                            fields: _vm.webServiceFields,
                                            selectable: "",
                                            "select-mode": "single",
                                          },
                                          on: {
                                            "row-selected":
                                              _vm.seeWebServiceDetails,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.configType !== "INTERPROCESS" && _vm.canAddConfig
              ? _c(
                  "b-row",
                  { staticClass: "justify-content-end mt-3 no-gutters" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary" },
                        on: { click: _vm.addConfig },
                      },
                      [
                        _c("i", { staticClass: "fa-light fa-plus fs-17px" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("common.routing.add_config"))),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }